var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductCatalogue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4536 12.2422C10.4536 11.828 10.7894 11.4922 11.2036 11.4922H15.4999C15.9141 11.4922 16.2499 11.828 16.2499 12.2422C16.2499 12.6564 15.9141 12.9922 15.4999 12.9922H11.2036C10.7894 12.9922 10.4536 12.6564 10.4536 12.2422Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3518 9.34375C13.766 9.34375 14.1018 9.67954 14.1018 10.0938V14.39C14.1018 14.8043 13.766 15.14 13.3518 15.14C12.9376 15.14 12.6018 14.8043 12.6018 14.39V10.0938C12.6018 9.67954 12.9376 9.34375 13.3518 9.34375Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.25098C2.30964 2.25098 1.75 2.81062 1.75 3.50098V12.3899C1.75 13.0802 2.30964 13.6399 3 13.6399H8.518C8.93221 13.6399 9.268 13.9757 9.268 14.3899C9.268 14.8041 8.93221 15.1399 8.518 15.1399H3C1.48122 15.1399 0.25 13.9087 0.25 12.3899V3.50098C0.25 1.98219 1.48122 0.750977 3 0.750977H5.1406C5.97601 0.750977 6.76612 1.13072 7.28799 1.78307L8.23516 2.96703C8.47238 3.26355 8.83152 3.43616 9.21125 3.43616H13.5C15.0188 3.43616 16.25 4.66738 16.25 6.18616V7.4119C16.25 7.82611 15.9142 8.1619 15.5 8.1619C15.0858 8.1619 14.75 7.82611 14.75 7.4119V6.18616C14.75 5.49581 14.1904 4.93616 13.5 4.93616H9.21125C8.37584 4.93616 7.58573 4.55641 7.06386 3.90407L6.11669 2.72011C5.87947 2.42359 5.52033 2.25098 5.1406 2.25098H3Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCatalogue);
export default __webpack_public_path__ + "static/media/product-catalogue.95c10554a6e7041975ae6f69760a58fc.svg";
export { ForwardRef as ReactComponent };